import React, {useRef, useState} from 'react';
import {Icons, DragDrop, Edit, Scrollable, ErrorBoundary} from 'components';
import {useLocation, useRouteMatch, useEvent} from 'helpers';
import css from './sidebar.module.scss';

export function Sidebar({className, children, ...props}) {
  const [popups, setPopups] = useState(0);
  const container = useRef();
  const {pathname} = useLocation();

  const contains = (id) => {
    if (id && window.document.getElementById(id)) {
      return container.current?.contains(window.document.getElementById(id));
    }
  };

  useEvent('popupopen', ({detail}) => {
    setPopups(count => count + (contains(detail.id) ? 1 : 0));
  });

  useEvent('popupkilled', ({detail}) => {
    setPopups(count => count + (contains(detail.id) ? -1 : 0));
  });

  return (
    <aside className={css('sidebar', 'popup-container', className, popups > 0 && 'has-popup-open')} ref={container} {...props}>
      <ErrorBoundary>
        { children }
      </ErrorBoundary>
    </aside>
  );
}

Sidebar.Scrollable = props => {
  const ref = useRef();
  return (
    <>
      <Scrollable
        {...props}
        ref={ref}
        className={['stretch-to-bottom', css.scrollable]}
        deps={[useRouteMatch().path]}
      />
      <DragDrop.Boundaries target={ref} />
    </>
  );
};

Sidebar.Search = props => (
  <div className={css.search}>
    <Edit
      {...props}
      placeholder="Search"
      Prefix={Icons.Search}
    />
  </div>
);
